import React from "react";
import { Modal, Button } from "@alpaca/framework";
import "./userDisableConfirmation.styles.scss";

function DisableConfirmation({ onCancel, open, onConfirm }) {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title="Disable User"
      width={450}
      height={300}
      footer={false}
      maskClosable={true}
    >
      <div className="disable-confirmation">
        <div className="header">
          <p>
            Are you sure you'd like to disable this user? This cannot be undone.
          </p>
        </div>
        <Button className="disable" danger onClick={onConfirm}>
          Disable
        </Button>
        <Button className="cancel" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </Modal>
  );
}

export default DisableConfirmation;
